'use strict';
import {stateGo} from 'redux-ui-router';
import {STATE_CHANGE_SUCCESS} from 'redux-ui-router/lib/action-types';
import 'rxjs/add/observable/empty';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/takeUntil';
import {Observable} from 'rxjs/Observable';
import {assignUserToModel} from '../../app/model/actions';
import {getUser} from '../../app/model/reducers/state';
import {getIsShowingModal} from '../../core-utilities/react-redux-modals';
import {onEnterView, onLeaveView} from '../../core-utilities/redux';
import {AbstractEpics} from '../../core-utilities/redux/AbstractEpics';
import {epicErrorHandler} from '../../core-utilities/rx-utils';
import {userStates} from '../../user/router-config';
import {getAuthModal, getIsAuthenticated} from '../reducers';
import {actions as authModalActions} from '../redux/authModal';
import {authStates} from '../router';
import {logger} from './logger';
import {POST_AUTH_STATE_KEY} from './stateGoPostAuth';


export class LoginViewEpics extends AbstractEpics {

  constructor(options) {
    super(options);

    this.onUserAndLoginView = this.onUserAndLoginView.bind(this);
    this.onLoginViewShowModal = this.onLoginViewShowModal.bind(this);
    this.onLeaveLoginViewHideModal = this.onLeaveLoginViewHideModal.bind(this);

    this.onUserAndLoginView.$inject = [
      'authCacheService',
    ];

    this.addEpics([
      this.onUserAndLoginView,
      this.onLoginViewShowModal,
      this.onLeaveLoginViewHideModal,
    ]);
  }

  onLoginViewShowModal(action$, store) {
    return onEnterView(action$, [authStates.login])
    // Show the AuthModal if user is not already logged in
      .switchMap(() =>
        getIsAuthenticated(store.getState())
          ? Observable.empty()
          : Observable.of(authModalActions.showModal({}))
      )
      .catch(epicErrorHandler(this.logger, 'onLoginViewShowModal'));
  }

  onLeaveLoginViewHideModal(action$, store) {
    return onLeaveView(action$, [authStates.login])
    // Show the AuthModal if user is not already logged in
      .switchMap(() =>
        getIsShowingModal(getAuthModal(store.getState()))
          ? Observable.of(authModalActions.hideModal({}))
          : Observable.empty()
      )
      .catch(epicErrorHandler(this.logger, 'onLoginViewShowModal'));
  }

  onUserAndLoginView(action$, store, dependencies) {
    return onEnterView(action$, [authStates.login, authStates.mobileLogin])
      .switchMap(() =>
        // Get the current user, if/when authenticated
        action$.ofType(assignUserToModel.TYPE)
          .map(userAction => userAction.payload.user)
          .startWith(getUser(store.getState()))
          .filter(user => !!user)
          // now that we have a user, check if there is a specific post-auth state we're supposed to navigate to.
          .switchMap(() => dependencies.authCacheService.getItem(POST_AUTH_STATE_KEY).catch(err => null))
          .takeUntil(action$.ofType(STATE_CHANGE_SUCCESS))
          // Navigate to either to cached state, or the default landing view
          .map(postState => {
            if (postState) {
              dependencies.authCacheService.removeItem(POST_AUTH_STATE_KEY);
              return stateGo(postState.toState, postState.toParams);
            } else {
              return stateGo(userStates.home);
            }
          })
      )
      .catch(epicErrorHandler(this.logger, 'onUserAndLoginView'));
  }
}

export const epics = new LoginViewEpics({logger}).epics;



// WEBPACK FOOTER //
// ./src/js/auth/epics/onLoginView.js